import Flight from "../models/flight";
import { FlightPlanPoint } from "../models/flightPlan";
import { RoutePoint, convertGeoPointToLatLon } from "../models/route";

//Form 731 is an HCAA form, so it applies to flights that depart from or arrive in Greece; intermediate
//stops are not considered. Mirrors functions/src/avitracer/brief/utils/insideGreece.ts, which rejects the
//form server side. ICAO aerodromes are Greek by their LG prefix; named points (helipads, strips) by their
//coordinates against a generous box around Greece.
const greeceBounds = { minLat: 34.7, maxLat: 41.8, minLon: 19.3, maxLon: 29.7 };

const isLatLonInGreece = ({ lat, lon }: { lat: number; lon: number }) =>
  lat >= greeceBounds.minLat && lat <= greeceBounds.maxLat && lon >= greeceBounds.minLon && lon <= greeceBounds.maxLon;

const isRoutePointInGreece = (point: RoutePoint): boolean =>
  point.name.match(/^[A-Z]{4}$/) ? point.name.startsWith("LG") : isLatLonInGreece(point);

const isFlightPlanPointInGreece = (point: FlightPlanPoint): boolean =>
  point.isIcao ? point.icaoCode.startsWith("LG") : isLatLonInGreece(convertGeoPointToLatLon(point.coords));

export function isFlightInsideGreece(flight: Flight): boolean {
  if (flight.route) {
    return isRoutePointInGreece(flight.route.departure) || isRoutePointInGreece(flight.route.destination);
  }
  if (!flight.customRoute) {
    return false;
  }
  return isFlightPlanPointInGreece(flight.customRoute.departure) || isFlightPlanPointInGreece(flight.customRoute.destination);
}

export const isFlightPlanInsideGreece = (flightPlan: { departure: FlightPlanPoint; destination: FlightPlanPoint }): boolean =>
  isFlightPlanPointInGreece(flightPlan.departure) || isFlightPlanPointInGreece(flightPlan.destination);
